/* The Panel Room logo mark — a brass "panel" of members between two rules,
   set on a deep green square. Same mark is used as the favicon. */
export const Logo = ({ className = "h-9 w-9" }) => (
    <svg viewBox="0 0 64 64" className={className} aria-hidden="true">
        <rect width="64" height="64" fill="var(--pine)" />
        <rect x="12" y="13" width="40" height="3" fill="var(--brass)" />
        <rect x="19" y="24" width="6" height="23" fill="var(--brass)" />
        <rect x="29" y="24" width="6" height="23" fill="var(--brass)" />
        <rect x="39" y="24" width="6" height="23" fill="var(--brass)" />
        <rect x="12" y="48" width="40" height="3" fill="var(--brass)" />
    </svg>
);
